import { render } from "./MngPayment.vue?vue&type=template&id=6a77a067&scoped=true&ts=true"
import script from "./MngPayment.vue?vue&type=script&lang=ts"
export * from "./MngPayment.vue?vue&type=script&lang=ts"

import "./MngPayment.vue?vue&type=style&index=0&id=6a77a067&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a77a067"]])

export default __exports__